type MakeChangeTuneConfig = {
  /**
   * Called when the user activates "Make Change" from the tune menu.
   * The tune should pass the tuned block id.
   */
  onMakeChangeRequested?: (blockId: string) => void;
};

/**
 * Global Editor.js block tune that adds a "Make Change" menu item.
 * It calls `config.onMakeChangeRequested(blockId)`.
 */
export default class MakeChangeTune {
  static get isTune() {
    return true;
  }

  private readonly api: any;
  private readonly config: MakeChangeTuneConfig;
  private readonly block: any;

  // Editor.js tune constructors may receive optional `config`, so we keep this signature loose.
  constructor({ api, config, block }: any) {
    this.api = api;
    this.config = config ?? {};
    this.block = block;
  }

  private getTunedBlockId(): string | null {
    const rawId =
      this.block?.id ??
      this.block?.blockId ??
      this.block?.holder?.dataset?.blockId ??
      this.block?.holder?.dataset?.id;

    if (typeof rawId === 'string' && rawId.trim().length > 0) return rawId;
    return null;
  }

  render() {
    const t = this.api?.i18n?.t as undefined | ((key: string) => string);
    const title = t?.('Make Change') ?? 'Make Change';

    const blockId = this.getTunedBlockId();

    return {
      icon: ' ',
      title,
      closeOnActivate: true,
      onActivate: () => {
        const cb = this.config?.onMakeChangeRequested;
        if (typeof cb !== 'function') return;
        if (!blockId) return;
        cb(blockId);
      },
    };
  }
}
